<div
  *ngIf="skills?.length > 0"
  class="skills-chip-list-container"
  data-testid="skill-chip-list-container"
>
  <div
    cdkDropList
    [cdkDropListData]="skills"
    [cdkDropListDisabled]="!dragDropEnabled"
    [cdkDropListSortingDisabled]="!dragDropEnabled || !ordering"
    (cdkDropListDropped)="onSkillDropped($event)"
    (cdkDropListEntered)="dragging = true"
    (cdkDropListExited)="dragging = false"
    [ngClass]="{
      'skills-chip-list-dragging': dragging && canReceiveDroppedSkills,
      'skills-chip-list-no-drop': dragging && !canReceiveDroppedSkills,
      'skills-chip-list-row': !ordering,
      'skills-chip-list-column': ordering
    }"
    data-testid="skill-chip-list-dropzone"
  >
    <div
      *ngFor="let skill of skills; trackBy: trackBySkill"
      cdkDrag
      [cdkDragData]="skill"
      [cdkDragDisabled]="!dragDropEnabled"
      [cdkDragLockAxis]="ordering ? 'y' : null"
      (cdkDragStarted)="onDragStarted()"
      (cdkDragEnded)="onDragEnded()"
      (click)="onChipClick(skill, $event)"
      [ngClass]="{
        'unknown-skill-chip': skill.SkillRating === 0,
        'moved-on-skill-chip': skill.SkillRating === 99,
        'willing-to-learn-skill-chip': skill.SkillRating === 1,
        'student-skill-chip': skill.SkillRating === 2,
        'proficient-skill-chip': skill.SkillRating === 3,
        'teacher-skill-chip': skill.SkillRating === 4,
        'leader-skill-chip': skill.SkillRating === 5,
        'skill-chip': true,
        'selected-skill-chip': isSelectedSkill(skill),
        'skill-chip-removable': showRemove,
        'skill-chip-ordering': ordering
      }"
      title="{{ clickActionCaption }} {{ skill.Name }}"
      data-qa="skill-chip"
      [attr.data-qa-value]="skill.Name"
      data-testid="skill-chip"
      [attr.data-skill-name]="skill.Name"
    >
      <div class="drop-placeholder" *cdkDragPlaceholder></div>

      <span class="skill-chip-text">
        {{ showRating ? (skill | skillAndRatingDisplay) : skill.Name }}
      </span>

      <button
        *ngIf="showRemove"
        type="button"
        class="skill-chip-remove"
        [attr.aria-label]="removeAriaLabel + ' ' + skill.Name"
        (click)="onRemoveClick(skill, $event)"
        data-testid="skill-chip-remove"
      >
        ×
      </button>
    </div>
  </div>
</div>

<div *ngIf="skills?.length === 0 && noSkillsCaption">
  <div
    cdkDropList
    cdkDropListSortingDisabled
    [cdkDropListDisabled]="!dragDropEnabled"
    (cdkDropListDropped)="onSkillDropped($event)"
    class="skills-chip-list-column skills-chip-list-empty"
    (cdkDropListEntered)="dragging = true"
    (cdkDropListExited)="dragging = false"
    [ngClass]="{
      'skills-chip-list-dragging': dragging && canReceiveDroppedSkills,
      'skills-chip-list-no-drop': dragging && !canReceiveDroppedSkills
    }"
    data-testid="skill-chip-list-empty"
  >
    <span>{{ noSkillsCaption }}</span>
  </div>
</div>
